import {
  useBalanceHub,
  useProviderHub,
  useTokenInfoHub,
} from '@aries/aptos-defi/common';
import { withLoadingNotify } from '@aries/aptos-defi/utils';
import { useWallet } from '@aries/aptos-defi/wallet';
import { getTFunction } from '@aries/shared/locale';
import Big from 'big.js';
import { compact } from 'lodash';
import { getUSDTFaucetSDK } from './usdt-sdk';

export const useFaucet = () => {
  const { getAddressWithNotify, walletAddress } = useWallet();

  const { balanceMap, refresh } = useBalanceHub();
  const { tokenMap, tokenList } = useTokenInfoHub();
  const { provider } = useProviderHub();

  const faucets = compact([
    // tokenMap[APTOS_COIN_ADDRESS] && {
    //   asset: {
    //     ...tokenMap[APTOS_COIN_ADDRESS],
    //     priceUSD: tokenMap[APTOS_COIN_ADDRESS].price.toFixed(6),
    //     priceUSDNum: tokenMap[APTOS_COIN_ADDRESS].price.toNumber(),
    //     id: APTOS_COIN_ADDRESS,
    //   },
    //   wallet: tokenMap[APTOS_COIN_ADDRESS].toAmount(
    //     balanceMap[APTOS_COIN_ADDRESS]?.amount ?? Big(0),
    //   ),
    //   airdrop: async () => {
    //     const address = await withLoadingNotify(
    //       Promise.resolve(getAddressWithNotify()),
    //     );
    //     if (!address) return;

    //     const asset = tokenMap[APTOS_COIN_ADDRESS];
    //     const res = await withLoadingNotify(
    //       faucetClient.fundAccount(address, 10 ** 10),
    //       {
    //         sendingTitle: `Airdroping ${asset.symbol}...`,
    //         sendSuccessTitle: 'Airdrop Success!',
    //         sendSuccessContent: `Asset added to your wallet.`,
    //       },
    //     );

    //     if (res) {
    //       refresh();
    //     }
    //   },
    // },
    ...tokenList
      .filter(v => v.symbol !== 'APT' && v.symbol.startsWith('dev'))
      .map(coin => {
        return {
          asset: coin,
          wallet: tokenMap[coin.id].toAmount(
            balanceMap[coin.id]?.amount ?? Big(0),
          ),
          airdrop: async () => {
            const t = getTFunction();
            const asset = tokenMap[coin.id];
            const res = await withLoadingNotify(
              (async () => {
                getAddressWithNotify();

                return provider.sendCustomTx({
                  function:
                    '0x498d8926f16eb9ca90cab1b3a26aa6f97a080b3fcbe6e83ae150b7243a00fb68::devnet_coins::mint_to_wallet',
                  arguments: ['100000000000'],
                  type: 'entry_function_payload',
                  type_arguments: [coin.id],
                });
              })(),
              {
                sendingTitle: t`Airdroping ${asset.symbol}...`,
                sendSuccessTitle: t`Airdrop Success!`,
                sendSuccessContent: t`Asset added to your wallet.`,
              },
            );

            if (res) {
              refresh();
            }
          },
        };
      }),
    ...tokenList
      .filter(v => v.symbol === 'USDT')
      .map(coin => {
        return {
          asset: coin,
          wallet: tokenMap[coin.id].toAmount(
            balanceMap[coin.id]?.amount ?? Big(0),
          ),
          airdrop: async () => {
            if (!walletAddress) {
              return;
            }

            const t = getTFunction();
            const asset = tokenMap[coin.id];
            const res = await withLoadingNotify(
              (async () => {
                getAddressWithNotify();

                return getUSDTFaucetSDK()
                  .usdt.mint({
                    to: walletAddress,
                    amount: asset.toLamports(1000000),
                  })
                  .execute();
              })(),
              {
                sendingTitle: t`Airdroping ${asset.symbol}...`,
                sendSuccessTitle: t`Airdrop Success!`,
                sendSuccessContent: t`Asset added to your wallet.`,
              },
            );

            if (res) {
              refresh();
            }
          },
        };
      }),
  ]);

  return {
    faucets,
  };
};
